import { createContext } from "react";

//form error

//form info
export interface IDocumentManagerFormContext {
  mode: "Edit" | "Add" | "Info";
}
export const DocumentManagerFormContext = createContext<IDocumentManagerFormContext | null>(null);
